import Vue from 'vue';
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import SpBetslip from '@nsftx/special-projects-retail-betslip-app/src/main';
import TicketPreview from '@nsftx/special-projects-ticket-preview/src/main';
// import SpBetslip from '../../special-projects-retail-betslip-app/src/main';
// import TicketPreview from '../../special-projects-ticket-preview/src/main';
import router from './router/index';
import createStore from './store/store';
import GatewaySrv from './services/gateway';
import SocketSrv from './services/socket';
import './filters';

import App from './App';


// const router = createRouter();
const store = createStore();

GatewaySrv.fetchGameId(store, router);

Vue.config.productionTip = false;
Vue.use(SpBetslip);
Vue.use(TicketPreview, {
  environment: 'retail',
});

store.watch(state => state.gatewayLoaded, () => {
  SocketSrv.connect(store);
  new Vue({
    store,
    router,
    render: h => h(App),
  }).$mount('#app');
});
